import { render, staticRenderFns } from "./TestTaskAdd.vue?vue&type=template&id=23c75121"
import script from "./TestTaskAdd.vue?vue&type=script&lang=js"
export * from "./TestTaskAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports